import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/municipios';

export default {
    getMunicipioById(idMunicipio) {
        return http.get({
            url: baseUrl + `/${idMunicipio}`,
            lockScreen: true,
            lockMessage: 'Buscando dados de município'
        });
    },
    ValidarMunicipioRaioAceiteCar(data, lockScreen = false) {
        return http.post({
            url: '/municipio-raio/validar',
            data: data,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    }
};
